import React, { useContext, useState } from 'react';
import { logoutGet } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import Loading from '../Loading';
import { logoutNotice, somethingWentWrongNotice } from '../UI/Notifications';

const Logout = () => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Logout");
    }

    setLoading(false);
  }

  const logOutHandler = () => {
    setLoading(true);
    logoutGet()
    .then(() => {
      setLoading(false);
      logoutNotice();
      logout();
    })
    .catch(error => handleDefaultStatusCodes(error.response.status));
  }

  return (
    <>
      <div
        className="Dropdown_Logout"
        onClick={logOutHandler}
      >
        <span className="ml-2">Log Out</span>
      </div>
      {loading && <Loading />}
    </>
  )
}

export default Logout;
